import { Form } from "react-bootstrap";
import { Controller } from "react-hook-form";
import InputMask from "react-input-mask";
const IController = ({ elment, item, control, errors, register }) => {
  var className = "";

  if (errors[elment]) {
    className = " form-control-invalid  is-invalid";
  }

  //
  return (
    <Controller
      name={elment}
      id={elment}
      placeholder={item?.placeholder}
      className={item?.className + className}
      control={control}
      rules={item?.rules && item.rules}
      render={({ field }) => (
        <>
          {/* <InputMask
            {...field}
            mask="+(999) 999-9999"
            maskChar={null}
            placeholder="Enter your phone number"
          >
            {(inputProps) => <input {...inputProps} type="tel" />}
          </InputMask> */}
          <Form.Control
            id={elment}
            className={item?.className + className}
            placeholder={item?.placeholder}
            type={item?.type}
            size={item?.size && item.size}
            {...field}
            {...register(elment)}
          />
          <Form.Control.Feedback type="invalid">
            {item?.messageError}
          </Form.Control.Feedback>
        </>
      )}
    />
  );
};

export default IController;
